import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { siQuoteUrls } from '../../../environments/environment';
import { GetDeviceAndPartIVKRequest, GetDeviceAndPartIVKResponse, 
  GetDevicesCpCostRequest, GetDevicesCpCostResponse, GetMultiPdfReportsRequest, GetMultiPdfReportsResponse, SaveOrSaveAsMultiPdfTemplateRequest, SaveOrSaveAsMultiPdfTemplateResponse, DeleteMultiPdfTemplateRequest, GetPartsCpCostRequest ,GetPartsCpCostResponse,GetPartTypeIdsResponse, MinimumProjectStandardMarginRequest, MinimumProjectStandardMarginResponse} from "../../models/dtos";
import { WiringTypes } from "../../models/reports/WiringTypes";
import { Cartoon } from "../../models/common/Cartoon";
import { BaseHttpService } from "./base-http.service";
import { GenericNameByCultureIDRequest } from "../../models/dtos/Classes/GenericNameByCultureIDRequest";
import { GenericNameByCultureIDResponse } from "../../models/dtos/Classes/GenericNameByCultureIDResponse";

@Injectable({
  providedIn: 'root'
})
export class ReportsAPIService {
  
  constructor(private readonly baseHttp: BaseHttpService) { }

  getDeviceAndPartIVK(requestBody: GetDeviceAndPartIVKRequest): Observable<Array<GetDeviceAndPartIVKResponse>> {
    return this.baseHttp.post<Array<GetDeviceAndPartIVKResponse>>(`${siQuoteUrls.reports}/GetDevicePartTypeIVK`, requestBody);
  }

  getPartTypeIdsNames(): Observable<Array<GetPartTypeIdsResponse>> {
    return this.baseHttp.get<Array<GetPartTypeIdsResponse>>(`${siQuoteUrls.reports}/GetPartTypeName`);
  }

  getGenericNameByCultureId(requestBody: GenericNameByCultureIDRequest): Observable<GenericNameByCultureIDResponse> {
    return this.baseHttp.post<GenericNameByCultureIDResponse>(`${siQuoteUrls.reports}/GetGenericNameByCultureID`, requestBody);
  }

  getWiringTypeData(): Observable<WiringTypes[]> {
    return this.baseHttp.get<WiringTypes[]>(`${siQuoteUrls.reports}/GetWiringTypes`);
  }

  getCartoonFiles(cartoonIds: string[]): Observable<Cartoon[]> {
    return this.baseHttp.post<Cartoon[]>(`${siQuoteUrls.reports}/GetCartoonsByIds`, cartoonIds);
  }

  getDevicesCpCost(request: GetDevicesCpCostRequest): Observable<GetDevicesCpCostResponse[]> {
    return this.baseHttp.post<GetDevicesCpCostResponse[]>(`${siQuoteUrls.reports}/GetDevicesCpCost`, request);
  }

   getPartsCpCost(request: GetPartsCpCostRequest): Observable<GetPartsCpCostResponse[]> {
    return this.baseHttp.post<GetPartsCpCostResponse[]>(`${siQuoteUrls.reports}/GetPartsCpCost`, request);
  }

  getMinimumProjectStandardMargin(requestBody: MinimumProjectStandardMarginRequest): Observable<MinimumProjectStandardMarginResponse> {
      return this.baseHttp.post<MinimumProjectStandardMarginResponse>(`${siQuoteUrls.metaData}/GetMinimumProjectStandardMargin`, requestBody);
  }

  saveOrSaveAsMultiPdfReport(request: SaveOrSaveAsMultiPdfTemplateRequest): Observable<SaveOrSaveAsMultiPdfTemplateResponse>{
    return this.baseHttp.post<SaveOrSaveAsMultiPdfTemplateResponse>(`${siQuoteUrls.reports}/SaveOrSaveAsMultiPdfTemplate`, request);
  }

  deleteMultiPdfReport(request: DeleteMultiPdfTemplateRequest): Observable<void>{
    return this.baseHttp.delete<void>(`${siQuoteUrls.reports}/DeleteMultiPdfTemplate`, request);
  }


}
